import { HonorRecordModel } from '@vp/honor/core/model/HonorRecordModel';
import { ProfileHonorRecordModel } from '@vp/profile/core/model/ProfileHonorRecordModel';

export abstract class HonorSubmitPort {
  abstract submitHonorRecord(record: HonorRecordModel, profileId: string, controller?: AbortController): Promise<ProfileHonorRecordModel>;
}
